import MyCollapse from "../../components/MyCollapse";

const KCDH01 = () => {
  const content = [
    {
      value: 1,
      title: "CDH 코호트 연구의 필요성",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text">
            <dl>
              <dt>01</dt>
              <dd>
                <p>
                  선천성 횡격막 탈장 (congenital diaphragmatic hernia, CDH)는
                  희귀질환으로 분류되지만 생후 초기 집중적인 치료와 수술을 받고
                  신생아 중환자실을 퇴원하게 되면 이후 대부분 비싼 약물이나
                  수술, 혹은 의료 장치에 의존하지 않고 정상적인 생활이
                  가능합니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <p>
                  CDH는 산전 진단과 평가로 비교적 정확하게 출생 후 생존율을
                  예측할 수 있습니다. 따라서 희귀 난치성 질환 진단이라는 막연한
                  두려움으로 인한 임신 중단을 막을 수 있습니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <p>
                  중증 신생아에 대한 이송과 다학제 집중 치료 시스템의 기반이
                  취약한 현재 국내 신생아 치료 환경에서는 CDH에 대한 새로운
                  치료법의 개발에 앞선 진료 전달 체계 확립이 필요합니다. 중증
                  환자는 체외막산소화술 (ECMO) 등 신생아과, 소아심장과,
                  소아흉부외과 등 다학제 집중치료의 경험이 많은 일부 병원으로
                  이송하여 출산하여 치료를 받는 것이 국내 CDH 생존율 향상에
                  기여할 수 있을 것으로 생각됩니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>04</dt>
              <dd>
                <p>
                  산전 자료 또는 늦어도 이송이 가능하다고 여겨지는 생후 첫 수
                  시간의 임상 지표에 근거한 사망 또는 ECMO 예측 프로그램
                  개발에는 충분한 데이터 확보가 필요하며 결국 전국 단위 CDH 환자
                  자료 등록이 선행되어야 합니다.
                </p>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
    {
      value: 2,
      title: "K-CDH의 목표",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text cdh2-1">
            <dl>
              <dt>01</dt>
              <dd>
                <h3>전국 단위 전향적 (prospective) 코호트를 구축합니다.</h3>
                <ul>
                  <li>
                    <span>•</span>주산기 (단기) 자료 수집: 산모, 태아는 물론
                    아기의 중환자실의 치료 지표를 수집합니다.
                  </li>
                  <li>
                    <span>•</span>외래 추적 (장기) 자료 수집: 퇴원 후 외래에서의
                    성장, 발달, 합병증 상태를 파악합니다.
                  </li>
                </ul>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h3>우리나라 고유의 CDH 표준 진료 지침을 제작합니다.</h3>
                <ul>
                  <li>
                    <span>•</span>산전 자료와 생후 초기 자료로 사망과 ECMO
                    가능성을 예측하는 공식을 개발합니다.
                  </li>
                  <li>
                    <span>•</span>생존율 향상과 장기 합병증 감소를 위한 치료
                    인자를 발굴합니다.
                  </li>
                  <li>
                    <span>•</span>학령기까지의 성장, 발달, 수술 후 합병증에 대한
                    객관적인 역학 자료를 수집합니다.
                  </li>
                </ul>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h3>CDH 연구를 위한 근거 데이터를 제공합니다.</h3>
                <ul>
                  <li>
                    <span>•</span>국제 학회와 학술지에 임상 연구 결과를
                    발표합니다.
                  </li>
                  <li>
                    <span>•</span>후보 치료법 개발의 플랫폼을 제공합니다.
                  </li>
                </ul>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="acco cdh">
      <MyCollapse data={content} />
    </div>
  );
};

export default KCDH01;
